// structure
export const FETCH_VACCINATION_COUNT_INIT = "VACCINATION_COUNT@FETCH_VACCINATION_COUNT_INIT"
export const FETCH_VACCINATION_COUNT_SUCCEDED = "VACCINATION_COUNT@FETCH_VACCINATION_COUNT_SUCCEDED"
export const FETCH_VACCINATION_COUNT_FAILED = "VACCINATION_COUNT@FETCH_VACCINATION_COUNT_FAILED"

// superset
export const FETCH_SUPERSET_TOKEN_INIT = "SUPERSET@FETCH_SUPERSET_TOKEN_INIT"
export const FETCH_SUPERSET_TOKEN_SUCCEDED = "SUPERSET@FETCH_SUPERSET_TOKEN_SUCCEDED"
export const FETCH_SUPERSET_TOKEN_FAILED = "SUPERSET@FETCH_SUPERSET_TOKEN_FAILED"
